import { useState } from 'react';
import { PlantListing } from './components/PlantListing';
import { CustomTypography } from 'app/shared/components/generic-ui/Typography/Typography';
import { useStyles } from './PlantSettings.styles';
import { translations } from 'app/locales/i18n';
import { useTranslation } from 'react-i18next';
import { generatePath, useNavigate } from 'react-router';
import { useRouteParams } from 'app/shared/hooks/useRouteParams';
import { Routes } from 'types';
import { TabIds } from 'app/shared/components/layout/TabNavigation/TabNavigation.types';
import { PlantCrossShipping } from './components/PlantCrossShipping';

enum Tab {
  LISTING = 'Listing',
  CROSS_SHIPPING = 'Cross Shipping',
}

const tabsOptions = [
  { id: Tab.LISTING, value: translations.plantListing.plantListing },
  { id: Tab.CROSS_SHIPPING, value: translations.plantListing.crossShipping },
];

export const PlantSettings = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState<string>(Tab.LISTING);
  const { classes } = useStyles();
  const navigate = useNavigate();
  const {
    perPage,
    organizationId,
  }: {
    perPage: string;
    organizationId: string;
  } = useRouteParams();
  return (
    <div>
      <div className={classes.tabNavigation}>
        {tabsOptions.map(el => {
          return (
            <div key={el.id} className={classes.borderContainer}>
              <div
                className={
                  activeTab === el.id
                    ? classes.tabElementActive
                    : classes.tabElement
                }
                key={el.id}
                onClick={() => {
                  setActiveTab(el.id);
                  navigate(
                    generatePath(`${Routes.OrganizationDetails}`, {
                      organizationId,
                      tab: TabIds.PLANT_TEAM,
                      page: '1',
                      perPage,
                    }),
                    { replace: true },
                  );
                }}
              >
                <CustomTypography
                  variant="bodySmall"
                  bold={activeTab === el.id}
                  color={activeTab === el.id ? 'accentDark' : 'greyscale1'}
                >
                  {t(el.value)}
                </CustomTypography>
              </div>

              {activeTab === el.id && <span className={classes.border}></span>}
            </div>
          );
        })}
      </div>
      {activeTab === Tab.LISTING && <PlantListing />}
      {activeTab === Tab.CROSS_SHIPPING && <PlantCrossShipping />}
    </div>
  );
};
